<template>
<div class="textcontentextreme">

  <br><br>
  <IconTable>
    <div slot="ico" class="fadein">
      <v-icon>computer</v-icon>
      <v-icon>smartphone</v-icon>
      <v-icon>watch</v-icon>
      <v-icon>developer_board</v-icon>
    </div>
    <div>
      <div class="display-1">What I'm working on</div>
      <br><br> As I code all this stuff in my free time there are not many things going on simultaniously. Whenever I have free time I try to improve my projects or start new ones.
      <br> Currently I am working on an clone of 8Pen.
    </div>
  </IconTable>
</div>
</template>

<script>
import IconTable from '../components/IconTable.vue'

export default {
  name: "latest-page",
  components: {
    IconTable
  }
}
</script>
<style lang="scss">
// https://snook.ca/archives/html_and_css/simplest-css-slideshow

@mixin fade($num:1, $fade:1, $visible:2) {
    $a: 100 / (($fade + $visible) * $num);
    @keyframes fade {
        0% {
            opacity: 0;
        }
        #{$a * $fade}% {
            opacity: 1;
        }
        #{$a * ($fade + $visible)}% {
            opacity: 1;
        }
        #{$a * ($fade + $visible + $fade)}% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }

    animation-name: fade;
    animation-duration: (($fade + $visible) * $num) + s;
    animation-iteration-count: infinite;

    @for $i from 1 through $num {
        &:nth-child(#{$i}) {
            animation-delay: (#{($fade + $visible) * ($i - 1) + 0.1}s); //Bug compiling to (0 + s) now 0s
        }
    }
}

.fadein i {
    position: absolute;

    font-size: 200px;
    opacity: 0;
    transform: translateX(-50%);
    @include fade($num:4, $fade:2, $visible:5);
}
.fadein {
    width: 100%;
    height: 200px;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/content/latest-page.vue